import { login, register, resetPassword } from '@/api/auth'
import { setToken, getToken, removeToken, setUserInfo, getUserInfo, removeUserInfo } from '@/utils/auth'

const state = {
  token: getToken(),
  userInfo: getUserInfo()
}

const getters = {
  userName: state => {
    return state.userInfo ? state.userInfo.username || state.userInfo.name || '游客' : '游客'
  }
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  CLEAR_USER: (state) => {
    state.token = ''
    state.userInfo = null
  }
}

const actions = {
  // 用户登录
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo)
        .then(response => {
          const { token } = response
          commit('SET_TOKEN', token)
          setToken(token)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 用户注册
  register({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      register(userInfo)
        .then(response => {
          const { token } = response
          commit('SET_TOKEN', token)
          setToken(token)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 重置密码
  resetPassword({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      resetPassword(userInfo)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 获取用户信息
  getUserInfo({ commit }, userInfo) {
    commit('SET_USER_INFO', userInfo)
    setUserInfo(userInfo)
  },

  // 退出登录
  logout({ commit }) {
    commit('CLEAR_USER')
    removeToken()
    removeUserInfo()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
} 


// WEBPACK FOOTER //
// ./src/store/modules/user.js